<h2 mat-dialog-title>Confirmation</h2>
<mat-dialog-content>
  <p>Are you sure you want to submit ?</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">No</button>
  <button mat-button color="primary" (click)="onConfirm()">Yes</button>
</mat-dialog-actions>